// extracted by mini-css-extract-plugin
module.exports = {"activity-mentions":"activity-mentions___1e_Xj","line-mention":"line-mention___2aV74"};